import React from 'react';
import { IDNameDescriptionItem, LeadModel, SPLeadModel } from '../models/superbit-api-models'
import { GeneralDataModel } from '../models/GeneralDataModel'
import { StatOptions } from 'fs';
import { Select, Tooltip } from 'antd';
import OpenLead from '../_OpenLead'
import moment from 'moment';
import { LinkToSimulator } from './_LinkToSimulator';
import generalSettings from '../json/general-settings.json';

import { IDNameDescriptionDictionary } from '../models/Site';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhoenixFramework } from '@fortawesome/free-brands-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import CallButton from '../components/_CallButton';
import { faFire } from '@fortawesome/free-solid-svg-icons';
import { LeadsModel } from '../models/LeadsModel';


type Props = {
    lead: SPLeadModel | null;
    oldLeadStatusesList: any[];
    getAuthorizedToDriveName: any;
    onEdit: Function;
    onDelete: Function;
    navigation?: any;
    opened?: boolean
    openPopupMessage?: Function;
    openDocumentPopup: Function;
    isAdmin?: boolean;
    updateLeadStatus: Function;
    leadStatuses: any[],
    onGoToSimulatorClick: Function;
    onCallStart: Function;
    checkPermissionsOfCreator: () => boolean;
    checkPermissionsOfEdit: () => boolean;
};

type State = {
    open: boolean,
    lead: LeadModel | undefined;
    showBtnOptions: boolean;
    showBtnOptionsMobile: boolean;
    leadId: string,
    address: any;
    leadTopTypeLabel: string,
    leadTypeLabel: string,
    propertyType: string;
    InsuranceTypes: IDNameDescriptionDictionary;
    PolicyTypes: IDNameDescriptionDictionary;
    insuranseType: any;
    policyType: any;
    showStatusSelect: boolean;
    simulatorPermission: boolean;
    isOusideUser: boolean;
};

export class Lead extends React.Component<Props, State> {
    leadId = '';
    leadRef: any;
    leadStatusCell: React.RefObject<any>;
    leadStatusSelect: React.RefObject<any>;
    emptyId = '00000000-0000-0000-0000-000000000000';

    constructor(props: any) {
        super(props);
        this.openLead = this.openLead.bind(this);
        let leadId = '0';

        if (this.props.lead && this.props.lead != null && this.props.lead.lead != null && this.props.lead.lead.id != null) {
            const lead = this.props.lead.lead;
            leadId = this.props.lead.lead.id;
        }
        this.state = {
            open: false,
            showBtnOptions: false,
            showBtnOptionsMobile: false,
            lead: this.props.lead ? this.props.lead.lead : new LeadModel(),
            leadId: leadId.toString(),
            address: null,
            leadTopTypeLabel: '',
            leadTypeLabel: '',
            propertyType: '',
            InsuranceTypes: generalSettings.InsuranceTypes,
            PolicyTypes: generalSettings.policyTypes,
            insuranseType: {},
            policyType: {},
            showStatusSelect: false,
            simulatorPermission: false,
            isOusideUser: false,
        }
        this.leadRef = React.createRef();
        this.leadStatusCell = React.createRef();
        this.leadStatusSelect = React.createRef();
        // this.dispatch = useDispatch();
    }

    componentDidMount() {
        moment.locale('he');
        this.onLoad();
        if (this.state.lead) {
            // console.log('lead loaded', this.state.lead.id)
            // console.log('opened', this.state.lead.id, this.props.opened)
        }
    }

    scrollToElement = () => {
        if (this.leadRef && this.leadRef.current) {
            this.leadRef.current.scrollIntoView();
        }
    };


    onLoad = () => {

        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            let moodelPermision = loggedUser.menuPermissions.find((p: any) => p.moduleName == 'Simulator');

            if (moodelPermision && moodelPermision.permissionType == 2) {
                this.setState({ simulatorPermission: true });
            } else {
                this.setState({ simulatorPermission: false });
            }

            if (loggedUser.role == 1 || loggedUser.role == 2 || loggedUser.role == 3 || loggedUser.role == 4) {
                this.setState({ isOusideUser: true });
            }
        }

        if (this.props.opened) {
            // this.setState({ open: true });
            this.openLead(true);
        }
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.id) {
            this.leadId = this.props.lead.lead.id;
            // this.props.lead.lead.deliveryDate = moment(this.props.lead.lead.deliveryDate).format('DD-MM-YYYY') == "01-01-0001" ? undefined : this.props.lead.lead.deliveryDate;
            // this.props.lead.lead.deliveryDate && moment(this.props.lead.lead.deliveryDate).isValid() && moment(this.props.lead.lead.deliveryDate).format('DD-MM-YYYY') !== '01-01-0001' ? moment(this.props.lead.lead.deliveryDate).format('DD-MM-YYYY') : ''}

            this.setState({
                leadId: this.leadId
            })
        }
        let address = null;
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.involvedAddress) {
            // console.log(this.props.lead.lead.involvedAddress);
            address = this.props.lead.lead.involvedAddress;
            this.setState({
                address: address
            })
        }

        const leadTypes: string[] = [
            'חדש',
            'סלקט',
            'משומש'
        ];
        const leadTopTypes: string[] = [
            'רכב',
            'דירה/עסק',
            'אחר'
        ];

        let leadTopTypeLabel = leadTopTypes[0];
        let leadType = 0;
        let leadTypeLabel = '';
        if (this.props.lead && this.props.lead.lead) {
            if (this.props.lead.lead.leadTopType && this.props.lead.lead.leadTopType > 0) {
                leadTopTypeLabel = '';
                leadTypeLabel = '';
            } else {
                if (this.props.lead.lead.leadType) {
                    leadType = this.props.lead.lead.leadType;
                }
                leadTypeLabel = leadTypes[leadType];
            }
        }

        const propertyTypes = [
            "דירה",
            "משרד",
            "בית פרטי",
            "עסק"
        ];
        let propertyType = propertyTypes[0];
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.propertyType) {
            propertyType = propertyTypes[this.props.lead.lead.propertyType];
        }
        let insuranseType = {};
        if (this.props.lead && this.props.lead.lead) {
            insuranseType = this.state.InsuranceTypes[(this.props.lead.lead as any).insuranceType];
        }
        let policyType = {};
        if (this.props.lead && this.props.lead.lead) {
            policyType = this.state.PolicyTypes[(this.props.lead.lead as any).policyType];
        }
        // console.log(insuranseType);
        this.setState({
            leadTopTypeLabel: leadTopTypeLabel,
            leadTypeLabel: leadTypeLabel,
            propertyType: propertyType,
            insuranseType: insuranseType,
            policyType: policyType
        })
    }

    hasPermission() {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            if ([1, 2, 3, 4, 5, 13, 14, 15, 16].includes(loggedUser.role)) {
                return false;
            }
        }
        return true;
    }

    openLead(closed?: boolean) {

        // check if mobile display then return
        if(window.innerWidth <= 800){
            return;
        }

        if (!this.hasPermission()) {
            return;
        }
        var open = closed ? true : !this.state.open;
        this.setState({ open: open });
        if (open) {
            this.scrollToElement();
        }
    }

    onEdit = () => {
        // console.log('Lead Edit', this.leadId )
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.id) {
            console.log('Lead Edit', this.props.lead.lead.id)
            this.props.onEdit(this.props.lead.lead.id);
        }
    }

    onDelete = () => {
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.id) {
            console.log('Lead Delete', this.props.lead.lead.id)
            this.props.onDelete(this.props.lead.lead.id);
        }
    }

    onSimulatorClick = () => {
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.id) {
            // console.log('Lead to Simulator', this.props.lead.lead.id)
            if (this.props.onGoToSimulatorClick) {
                this.props.onGoToSimulatorClick(this.props.lead.lead.id);
            }
        }
        // localStorage.setItem('leadid', this.state.leadId);
        // console.log('Lead to Simulator', this.state.leadId)
    }

    toggleBtnMenu() {
        const curentState = this.state.showBtnOptions;
        this.setState({
            showBtnOptions: !curentState
        })
    }

    toggleBtnMenuMobile() {
        const curentState = this.state.showBtnOptionsMobile;
        this.setState({
            showBtnOptionsMobile: !curentState
        })
    }

    onActionBtnClick(e: any) {
        e.preventDefault();
        console.log('onActionBtnClick', e, e.target.className);
        this.toggleBtnMenu()
    }

    onActionBtnClickMobile(e: any) {
        e.preventDefault();

        console.log('onActionBtnClick', e, e.target.className);
        this.toggleBtnMenuMobile()
    }

    onRowClick(e: any) {
        if (e.target.parentElement.className.indexOf('cell') >= 0) {
            if (e.target.className == 'act-btn-icon icon menu-hamburger pointer' ||
                e.target.className == 'action-btn-menu-item pointer' ||
                e.target.className == 'ant-select-selection-item' ||
                e.target.className == 'ant-select-item-option-content' ||
                e.target.className == 'icon paperclip pointer' ||
                e.target.className == 'description bold cell-value phone-number' ||
                e.target.parentElement.className == 'cell car-details' ||
                e.target.parentElement.className.indexOf('on-click-ignore') > 0
            ) return;
            try {
                if (this.leadStatusCell.current && this.leadStatusCell.current.contains(e.target)) {
                    return;
                }
                if (this.leadStatusSelect && this.leadStatusSelect.current && this.leadStatusSelect.current.contains(e.target)) {
                    return;
                }
            } catch (error) {
                // return;
            }
            this.setState({
                showStatusSelect: false
            })
            this.openLead(!this.state.open);
        }
        if (e.target.className == 'act-btn-icon icon menu-hamburger pointer' ||
            e.target.className == 'action-btn-menu-item pointer' ||
            e.target.className == 'ant-select-selection-item' ||
            e.target.className == 'ant-select-item-option-content' ||
            e.target.className == 'icon paperclip pointer' ||
            e.target.className == 'description bold cell-value phone-number' ||
            e.target.parentElement.className == 'cell car-details' ||
            e.target.parentElement.className.indexOf('on-click-ignore') > 0
        ) return;
    }

    onMenuClick(action: string, value?: string) {
        // console.log(action);
        switch (action) {
            case 'edit':
                this.onEdit();
                break;
            case 'delete':
                this.onDelete();
                break;
            case 'simulator': {
                // console.log('LeadId', this.state.leadId, this.props);
                localStorage.setItem('leadid', this.state.leadId)
                break;
            }
            default:
                break;
        }
        this.toggleBtnMenu()
        this.toggleBtnMenuMobile()
    }

    openPopupMessage(d: any) {
        if (this.props.openPopupMessage) {
            this.props.openPopupMessage(d);
        }
    }

    openDocumentPopup() {
        if (this.props.lead && this.props.lead.lead) {
            const lead = this.props.lead.lead;
            if (lead.carLicenseFilePath) {
                this.props.openDocumentPopup(lead.carLicenseFilePath)
            } else {
                if (lead.vehicle) {
                    const vehicle = lead.vehicle;
                    if (vehicle != null && typeof vehicle.carLicenseFilePath != 'undefined' && vehicle.carLicenseFilePath) {
                        this.props.openDocumentPopup(vehicle.carLicenseFilePath)
                    }
                }
            }
        }
    }

    Call(e: any) {
        e.stopPropagation();
        if (this.props.lead && this.props.lead.lead && this.props.lead.lead.phoneNumber1 && this.props.lead.lead.id) {
            new GeneralDataModel().speakComSendCall(this.props.lead.lead.phoneNumber1, this.props.lead.lead.id);
            // this.dispatch(startCall());
        }
    }

    toggleShowStatuses() {

        if (this.state.isOusideUser == false) {
            this.setState({
                showStatusSelect: !this.state.showStatusSelect
            })
        }
    }

    updateLeadStatus(statusId: string) {
        if (this.props.updateLeadStatus && this.props.lead && this.props.lead.lead) {
            this.props.updateLeadStatus(this.props.lead.lead.id, statusId);
            this.setState({
                showStatusSelect: false
            })
        }
    }

    getPermission() {
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            if (loggedUser.role == 7 || this.props.isAdmin) {
                return true;
            }
        }
        return false;
    }

    hasNoPermissionToChangeStatus(statusId: string) {
        const loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            const user = JSON.parse(loggedUser);
            if (user.role == 0 || user.role == 7) {
                return false;
            }
        }
        console.log('statusId.toLowerCase()', statusId.toLowerCase())
        const hasFound = this.props.oldLeadStatusesList.find(s => {
            if (s.value.toLowerCase() == statusId.toLowerCase()) {
                console.log('hasFound-s', s.value.toLowerCase(), statusId.toLowerCase())
                return s;
            }
        }
        );
        if (hasFound == undefined || hasFound == null) {
            console.log('hasFound', hasFound)

            return true;
        }
        // if(statusId == ('0E310E7E-599A-4494-9957-307DEBAFD60F').toLowerCase() || statusId == ('4AB35B4C-9EB1-4DC5-ACC3-600C6BFF54B2').toLowerCase()
        //      || statusId == ('373A71C4-3247-4301-91B6-8C455DA65AE0').toLowerCase() || statusId == ('C5E660EC-C3E3-44C7-B881-90671D077731').toLowerCase()) {
        //         return true;
        //      }
        return false;
    }

    render() {
        let vehicle = null;

        if (this.props.lead && this.props.lead != null && this.props.lead.lead != null)
            vehicle = this.props.lead.lead.vehicle;
        return (
            <div ref={this.leadRef} >
                {this.props.lead != null && this.props.lead.lead != null ? (
                    <>
                        <div className={this.state.open ? "hide" : "wrapper-lead"} onClick={(e: any) => this.onRowClick(e)} id={`lead-row-${this.props.lead.lead.id}`}>

                            <div className='lead-data-row'>
                                <div className="icon-item icon-cell desktop-only widthCol1">

                                    {this.props.lead.level != null && this.props.lead.level == 1 ? <div className="icon tag"></div> : ""}
                                    {this.props.lead.level != null && this.props.lead.level == 2 ? <><FontAwesomeIcon icon={faFire} />4</> : ""}
                                    {this.props.lead.level != null && this.props.lead.level == 3 ? <><FontAwesomeIcon icon={faFire} />5</> : ""}
                                    {/* <div className={this.props.lead.lead != null && (this.props.lead.lead as any).simulatorOfferStage >= 0 ? "icon tag" : ""}></div> */}
                                </div>
                                <div className="status" ref={this.leadStatusCell} style={{ minWidth: '110px' }}>
                                    <div className="title">סטטוס:</div>
                                    <div className="flex-end" style={{ width: '100px' }}>
                                        <div className={`status flex-centered flex-space-between ${!this.state.showStatusSelect ? '' : 'hide'}`} onClick={() => {
                                            if (this.props.lead && this.hasNoPermissionToChangeStatus(this.props.lead.lastStatusId || '')) {
                                                console.log('no permission to change status');
                                                return;
                                            }
                                            this.toggleShowStatuses();
                                        }}>
                                            <div className="status-circle"></div>
                                            <div className="sub-title">{this.props.lead.lastStatusName}</div>
                                            <div className="qty">
                                                <div className={this.props.lead.lead.doubleLead ? "qty-circle" : "hide"}></div>
                                                <div className={this.props.lead.lead.doubleLead ? "qty-number flex-centered flex-justify-center" : "hide"}>x2</div>
                                            </div>
                                        </div>
                                        <div className={`${this.state.showStatusSelect ? '' : 'hide'}`}>
                                            <Select ref={this.leadStatusSelect}
                                                allowClear
                                                disabled={this.hasNoPermissionToChangeStatus(this.props.lead.lastStatusId || '') ? true : false}
                                                style={{ width: '90px' }}
                                                defaultValue={this.props.lead.lastStatusId}
                                                onChange={(v: string) => this.updateLeadStatus(v)}
                                                options={this.props.leadStatuses.map(
                                                    (item: any) => ({ label: item.text, value: item.value }))}
                                            />
                                        </div>

                                    </div>
                                </div>
                                <div className="date-item-start">
                                    <div className="title">תאריך יצירה:</div>

                                    <div className="description cell-value bold">
                                        {moment(this.props.lead.lead.createdDate).format('DD-MM-YYYY')}
                                    </div>
                                    <div className="description">
                                        {(moment(this.props.lead.lead.createdDate)).format('HH:mm')}
                                    </div>
                                </div>
                                <div className="brunch-item long">
                                    <div className="title">סניף:</div>
                                    <div className="description cell-value bold">
                                        {this.props.lead.branchesPath}
                                    </div>
                                </div>
                                <div className="stage-item">
                                    <div className="title">עמדה:</div>
                                    <div className="description cell-value">
                                        {this.props.lead.lead.stationUser != null ? this.props.lead.lead.stationUser.fullName : ""}
                                    </div>
                                </div>
                                <div className="handler-item desktop-only">
                                    <div className="title">מטפל</div>
                                    <div className="description cell-value">
                                        {this.props.lead.lead.handler != null ? this.props.lead.lead.handler.fullName : ""}
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <div className="title">איש קשר:</div>
                                    <div className="description cell-value bold">
                                        {this.props.lead.lead != null ? this.props.lead.lead.firstName + " " + this.props.lead.lead.lastName : ""}
                                    </div>
                                </div>
                                <div className="phone-item phone-number on-click-ignore">
                                    <div className="title">טלפון:</div>
                                    <div className="description bold cell-value phone-number">
                                        <div className="">{this.props.lead.lead.phoneNumber1}</div>
                                        <CallButton onStart={(e: any) => this.Call(e)} user={{
                                            userName: this.props.lead.lead.firstName + " " + this.props.lead.lead.lastName,
                                            userPhone: this.props.lead.lead.phoneNumber1
                                        }} />
                                        {/* <div className='pointer' onClick={(e:any)=>this.Call(e)}><FontAwesomeIcon icon={faPhone} /></div> */}
                                    </div>

                                </div>

                                {/* מסמך רישיון */}
                                <div className="docs-item document-cell desktop-only">
                                    <div className={this.props.lead.lead.carLicenseFilePath || (vehicle != null && typeof vehicle.carLicenseFilePath != 'undefined' && vehicle.carLicenseFilePath) ? "icon paperclip pointer" : ""}
                                        onClick={() => { this.openDocumentPopup() }}></div>
                                </div>

                                <div className="prapaty-item car-details on-click-ignore">
                                    <div className="title">נכס:</div>
                                    {
                                        this.props.lead.lead.leadTopType == 0 ? (<>
                                            <div className="sub-title">{vehicle != null && vehicle.vehicleSubModel != null ? vehicle.vehicleSubModel.modelCode : ""}</div>
                                            <div className="description">{vehicle != null && vehicle.vehicleSubModel != null ? vehicle.vehicleSubModel.name : ""}</div>
                                            <div className="description">{vehicle != null && vehicle.vehicleSubModel != null ? vehicle.licenseNumber : ""}</div>
                                        </>) : ''
                                    }
                                    {
                                        this.props.lead.lead.leadTopType == 1 && this.props.lead.lead.involvedAddress ? (<>
                                            <div className="sub-title">{this.state.propertyType}</div>
                                            <div className="description">{this.props.lead.lead.involvedAddress.street} {this.props.lead.lead.involvedAddress.houseNumber}/{this.props.lead.lead.involvedAddress.apartmentNumber} {this.props.lead.lead.involvedAddress.city}</div>
                                        </>) : ''
                                    }
                                    {
                                        this.props.lead.lead.leadTopType == 2 ? (<>
                                            <div className="sub-title">
                                                אחר
                                            </div>
                                            {this.props.lead.lead.policyType && this.state.PolicyTypes[this.props.lead.lead.policyType] && this.state.PolicyTypes[this.props.lead.lead.policyType].description ? (
                                                <div className="description" title={this.state.PolicyTypes[this.props.lead.lead.policyType].description}>
                                                    {this.state.PolicyTypes[this.props.lead.lead.policyType].description} <br />
                                                </div>
                                            ) : ''
                                            }

                                        </>) : ''
                                    }
                                </div>
                                <div className="leadType-item car-details desktop-only">
                                    <div className="title">
                                        סוג ליד:
                                    </div>

                                    <div className="description bold">
                                        {this.state.leadTypeLabel}
                                    </div>
                                </div>
                                <div className="year-item year-cell desktop-only">
                                    <div className="title">שנה:</div>
                                    {
                                        this.props.lead.lead.leadTopType == 0 ? (<>
                                            <div className="sub-title">
                                                {vehicle != null && vehicle.vehicleSubModel != null ? vehicle.carYear : ""}
                                            </div>
                                        </>) : ''
                                    }

                                </div>
                                <div className="comment-item notes">
                                    <div className="title">
                                        הערות:
                                    </div>
                                    <div className="description cell-value">

                                        {this.props.lead.lead.internalComment && this.props.lead.lead.internalComment !== '' ? (<>

                                            <Tooltip title={this.props.lead.lead.internalComment} color={'#027BFD'} placement="right">
                                                <div className='icon info pointer'></div>
                                            </Tooltip>
                                        </>) : (<></>)}
                                    </div>
                                </div>
                                <div className="cell desktop-only" style={{ marginRight: '30px' }}>
                                    <div className="description cell-value">
                                        {this.props.lead.lead.deliveryDate && moment(this.props.lead.lead.deliveryDate).isValid() && moment(this.props.lead.lead.deliveryDate).format('DD-MM-YYYY') != '01-01-0001' ? moment(this.props.lead.lead.deliveryDate).format('DD-MM-YYYY') : ''}
                                    </div>
                                </div>
                                <div className='button-item desktop-only' style={{ marginRight: '30px' }}>

                                    {/* פעולות */}
                                    <div className='act-btn-icon icon menu-hamburger pointer'
                                        onClick={(e: any) => { this.onActionBtnClick(e) }}></div>
                                    {this.state.showBtnOptions && (
                                        <ul className="btn-menu">
                                            {this.props.checkPermissionsOfEdit() ? (
                                                <li className="action-btn-menu-item pointer"
                                                    onClick={() => { this.onMenuClick('edit') }}
                                                >
                                                    ערוך
                                                </li>
                                            ) : (<></>)}
                                            {
                                                this.getPermission() ? (<>
                                                    <li className="action-btn-menu-item pointer"
                                                        onClick={() => { this.onMenuClick('delete') }}
                                                    >
                                                        מחק
                                                    </li>
                                                </>) : (<></>)
                                            }
                                            <li className="action-btn-menu-item pointer">
                                                הדפס
                                            </li>

                                            {this.state.simulatorPermission &&
                                                this.props.lead && this.props.lead.lead && this.props.lead.lead.id && this.props.lead.lead.leadTopType == 0 && ((this.props.lead.lead.vehicleId && this.props.lead.lead.vehicleId !== this.emptyId) || this.props.lead.lead.vehicle && this.props.lead.lead.vehicle.id && this.props.lead.lead.vehicle.id !== this.emptyId) && (
                                                    <LinkToSimulator
                                                        onClick={() => { this.onSimulatorClick() }}
                                                        leadId={this.props.lead.lead.id}
                                                    ></LinkToSimulator>
                                                )
                                            }
                                        </ul>
                                    )}
                                </div>
                                <div className="action" style={{ marginRight: '30px' }}>
                                    <div className="icon left-arrow" onClick={(e: any) => this.openLead()}></div>
                                </div>


                            </div>
                            <div>

                                <div className="bottom-row flex-space-between flex-centered">
                                    <div className="bottom-actions flex-space-between flex-centered">
                                        <div className="icon-item icon-cell widthCol1">

                                            {this.props.lead.level != null && this.props.lead.level == 1 ? <div className="icon tag"></div> : ""}
                                            {this.props.lead.level != null && this.props.lead.level == 2 ? <><FontAwesomeIcon icon={faFire} />4</> : ""}
                                            {this.props.lead.level != null && this.props.lead.level == 3 ? <><FontAwesomeIcon icon={faFire} />5</> : ""}
                                            {/* <div className={this.props.lead.lead != null && (this.props.lead.lead as any).simulatorOfferStage >= 0 ? "icon tag" : ""}></div> */}
                                        </div>
                                        <div className="license flex-space-between flex-centered">
                                            <div className={this.props.lead.lead.carLicenseFilePath || (vehicle != null && typeof vehicle.carLicenseFilePath != 'undefined' && vehicle.carLicenseFilePath) ? "icon paperclip pointer" : ""}
                                                onClick={() => { this.openDocumentPopup() }}></div>
                                        </div>
                                    </div>
                                    <button className="act-btn-mobile" onClick={(e: any) => { this.onActionBtnClickMobile(e) }}>פעולות</button>
                                    {this.state.showBtnOptionsMobile && (
                                        <ul className="btn-menu">
                                            {this.props.checkPermissionsOfEdit() ? (
                                                <li className="action-btn-menu-item pointer"
                                                    onClick={() => { this.onMenuClick('edit') }}
                                                >
                                                    ערוך
                                                </li>
                                            ) : (<></>)}
                                            {
                                                this.getPermission() ? (<>
                                                    <li className="action-btn-menu-item pointer"
                                                        onClick={() => { this.onMenuClick('delete') }}
                                                    >
                                                        מחק
                                                    </li>
                                                </>) : (<></>)
                                            }
                                            <li className="action-btn-menu-item pointer">
                                                הדפס
                                            </li>

                                            {this.state.simulatorPermission &&
                                                this.props.lead && this.props.lead.lead && this.props.lead.lead.id && this.props.lead.lead.leadTopType == 0  && ((this.props.lead.lead.vehicleId && this.props.lead.lead.vehicleId !== this.emptyId) || this.props.lead.lead.vehicle && this.props.lead.lead.vehicle.id && this.props.lead.lead.vehicle.id !== this.emptyId) && (
                                                    <LinkToSimulator
                                                        onClick={() => { this.onSimulatorClick() }}
                                                        leadId={this.props.lead.lead.id}
                                                    ></LinkToSimulator>
                                                )
                                            }
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>

                        {this.state.open ? (
                            <OpenLead
                                getAuthorizedToDriveName={this.props.getAuthorizedToDriveName}
                                lead={this.props.lead}
                                open={this.state.open}
                                closeLead={this.openLead}
                                onMenuClick={(e: any) => this.onMenuClick(e)}
                                openPopupMessage={(d: any) => this.openPopupMessage(d)}
                                simulatorPermission={this.state.simulatorPermission}
                                isAdmin={this.props.isAdmin}
                            ></OpenLead>
                        ) : ''}
                    </>
                ) : (
                    <p>No lead</p>
                )}
            </div>



        );
    }
}
